// DatabaseSettingsRelatedTab.jsx

import React from 'react';

// CSS
import './DatabaseSettingsRelatedTab.css';

// Components
import RegistryChildren from 'admin/nodetypes/children/RegistryChildren';
import Button from 'components/button/Button';
import ModalButtons from 'components/modal/buttons/ModalButtons';

/**
 * DatabaseSettingsRelatedTab
 *
 * Edits related types (`suggestedChildren`) for a custom collection.
 *
 * @param {string[]} suggestedChildren - Draft related type keys.
 * @param {function} setSuggestedChildren - Updates related type keys.
 * @param {object[]} typeOptions - Available node type definitions for pickers.
 * @param {string} [hostTypeKey] - Type key of the collection being edited.
 * @param {boolean} saving - Whether a related-settings save is in progress.
 * @param {boolean} canSave - Whether related settings can currently be saved.
 * @param {function} handleSave - Persists the current related-settings draft.
 *
 * @returns {ReactNode} The rendered related tab content.
 */
const DatabaseSettingsRelatedTab = React.memo(({
  suggestedChildren = [],
  setSuggestedChildren,
  typeOptions = [],
  hostTypeKey = '',
  saving = false,
  canSave = false,
  handleSave,
}) => {

  // ----- RENDER ----- //

  return (
    <div className="database-modal-related">

      {/* CONTENT */}
      <div className="database-modal-related-content">
        <RegistryChildren
          suggestedChildren={suggestedChildren}
          types={typeOptions}
          hostTypeKey={hostTypeKey}
          showTypeKeys={false}
          onSuggestedChange={setSuggestedChildren}
        />
      </div>

      {/* ACTIONS */}
      <div className="database-modal-related-actions">
        <ModalButtons
          style={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
        >
          <div className="database-modal-related-actions-right">
            <Button
              iconKey="check"
              label={saving ? 'Saving...' : 'Save Changes'}
              enabled={canSave}
              onClick={handleSave}
            />
          </div>
        </ModalButtons>
      </div>
    </div>
  );
});

// Dev Tools
DatabaseSettingsRelatedTab.displayName = 'DatabaseSettingsRelatedTab';

export default DatabaseSettingsRelatedTab;
